import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

const LinksList = ({ backgroundColor, columns }) => {
  return (
    <div>
      <div
        className="services-list-container-desktop"
        style={{ marginBottom: 40 }}
      >
        {columns?.map((column, i) => (
          <div
            key={i}
            className="service-list"
            style={{
              backgroundColor: backgroundColor ? backgroundColor : "#1b2636",
            }}
          >
            <h2 className="service-list-title">{column.title}</h2>
            {column.links?.map((link, j) => (
              <Link key={j} to={link.uri} className="service-list-item">
                <p className="service-list-label">{link.title}</p>
                <ArrowRightAltIcon />
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

LinksList.propTypes = {
  backgroundColor: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          uri: PropTypes.string,
          title: PropTypes.string,
        })
      ),
    })
  ),
};

LinksList.defaultProps = {
  backgroundColor: undefined,
  columns: undefined,
};

export default LinksList;
